export var ConditionalOperator;
(function (ConditionalOperator) {
    ConditionalOperator["NULL"] = "isNull";
    ConditionalOperator["NOT_NULL"] = "notNull";
    ConditionalOperator["EQUALS"] = "equals";
    ConditionalOperator["NOT_EQUALS"] = "notEquals";
    ConditionalOperator["STARTS_WITH"] = "startsWith";
    ConditionalOperator["ENDS_WITH"] = "endsWith";
    ConditionalOperator["INCLUDE"] = "include";
    ConditionalOperator["NOT_INCLUDE"] = "doesNotInclude";
    ConditionalOperator["LESS_THAN"] = "lessThan";
    ConditionalOperator["LESS_THAN_OR_EQUAL"] = "lessThanOrEqual";
    ConditionalOperator["GREATER_THAN"] = "greaterThan";
    ConditionalOperator["GREATER_THAN_OR_EQUAL"] = "greaterThanOrEqual";
    ConditionalOperator["IN_THE_PAST"] = "inThePast";
    ConditionalOperator["NOT_IN_THE_PAST"] = "notInThePast";
    ConditionalOperator["IN_THE_NEXT"] = "inTheNext";
    ConditionalOperator["IN_THE_CURRENT"] = "inTheCurrent";
    ConditionalOperator["NOT_IN_THE_CURRENT"] = "notInTheCurrent";
    ConditionalOperator["IN_BETWEEN"] = "inBetween";
    ConditionalOperator["NOT_IN_BETWEEN"] = "notInBetween";
})(ConditionalOperator || (ConditionalOperator = {}));
//# sourceMappingURL=conditionalRule.js.map